export function suggestMatchNote(row: {
  matchedFormerName?: string | null;
  matchedPerson?: string | null;
}): string | null {
  return row.matchedFormerName?.trim() || row.matchedPerson?.trim() || null;
}
